import type { MarketingDocContent } from '../types';

/** Cookie section derived from backend privacy policy (legacy visime.ch). */
export const cookieRichtlinieDe: MarketingDocContent = {
  slug: 'cookie-richtlinie',
  title: 'Cookie-Richtlinie',
  updated: '2018-11-19',
  description: 'Informationen zur Verwendung von Cookies auf visime.com.',
  sections: [
    {
      heading: 'Was sind Cookies?',
      paragraphs: [
        'Cookies sind kleine Textdateien, die auf Ihrem Gerät gespeichert werden, wenn Sie eine Website oder App nutzen. Wir verwenden Cookies und ähnliche Technologien (z. B. Local Storage), um den Dienst zu betreiben, Einstellungen zu speichern und die Nutzung zu analysieren.',
      ],
    },
    {
      heading: 'Welche Cookies wir verwenden',
      paragraphs: [],
      list: [
        'Session-Cookies — für den Betrieb des Dienstes und Anmeldung',
        'Präferenz-Cookies — z. B. Sprache, Darstellung (Hell/Dunkel)',
        'Sicherheits-Cookies — zum Schutz vor Missbrauch',
        'Analyse-Cookies — zur Verbesserung des Dienstes (z. B. über Firebase/Google)',
      ],
    },
    {
      heading: 'Ihre Wahlmöglichkeiten',
      paragraphs: [
        'Sie können Ihren Browser so einstellen, dass Cookies abgelehnt oder gelöscht werden. Ohne bestimmte Cookies stehen möglicherweise nicht alle Funktionen der Website oder App zur Verfügung.',
        'Details zur Verarbeitung personenbezogener Daten finden Sie in unserer Datenschutzerklärung.',
      ],
    },
  ],
};
